export const train = {
  periods: [{
    value: 1,
    label: '一期'
  }, {
    value: 2,
    label: '二期'
  }, {
    value: 3,
    label: '三期'
  }, {
    value: 4,
    label: '四期'
  }, {
    value: 5,
    label: '五期'
  }, {
    value: 6,
    label: '六期'
  }, {
    value: 7,
    label: '七期'
  }, {
    value: 8,
    label: '八期'
  }, {
    value: 9,
    label: '九期'
  }, {
    value: 10,
    label: '十期'
  }, {
    value: 11,
    label: '十一期'
  }, {
    value: 12,
    label: '十二期'
  }],
  trainStatus: [{
    value: 1,
    label: '立即启动'
  }, {
    value: 2,
    label: '待启动'
  }, {
    value: 3,
    label: '有效'
  }, {
    value: 4,
    label: '无效'
  }, {
    value: 5,
    label: '终止'
  }, {
    value: 6,
    label: '审批未通过'
  }],
  trainType: [{
    value: 1,
    label: '销售类'
  }, {
    value: 2,
    label: '管理类'
  }, {
    value: 3,
    label: '讲师类'
  }, {
    value: 4,
    label: '后援管理类'
  }, {
    value: 5,
    label: '其他类'
  }],
  trainWay: [{
    value: 1,
    label: '线上'
  /* }, {
    value: 2,
    label: '线下' */
  }],
  filterTrainWay: [{
    value: 1,
    label: '线上'
  }, {
    value: 2,
    label: '线下'
  }, {
    value: 3,
    label: '线上+线下'
  }],
  classStatus: [{
    value: 1,
    label: '有效'
  }, {
    value: 2,
    label: '无效'
  }, {
    value: 3,
    label: '完结'
  }],
  trainResult: [{
    value: 0,
    label: '通过'
  }, {
    value: 1,
    label: '不通过'
  }],
  studentStatus: [{
    value: 1,
    label: '结训'
  }, {
    value: 2,
    label: '未结训'
  }],
  levelLecturer: [{
    value: 1,
    label: '初级'
  }, {
    value: 2,
    label: '中级'
  }, {
    value: 3,
    label: '高级'
  }],
  authorizationType: [{
    value: 1,
    label: '销售类'
  }, {
    value: 2,
    label: '管理类'
  }, {
    value: 3,
    label: '讲师类'
  }, {
    value: 4,
    label: '后援管理类'
  }, {
    value: 5,
    label: '其它类'
  }],
  lecturerType: [{
    value: 1,
    label: '专职'
  }, {
    value: 2,
    label: '兼职'
  }, {
    value: 3,
    label: '外部'
  }],
  lecturerStatus: [{
    value: 1,
    label: '有效'
  }, {
    value: 2,
    label: '无效'
  }],
  curriculumStatus: [{
    value: 1,
    label: '待审核'
  }, {
    value: 2,
    label: '有效'
  }, {
    value: 3,
    label: '无效'
  }, {
    value: 4,
    label: '审批未通过'
  }],
  learningTimeDateType: [{
    value: 1,
    label: '岗前培训完成时间'
  }]
}

export default {
  train
}



// WEBPACK FOOTER //
// ./src/data/train.js